import { Controller } from 'react-hook-form'
import TextField from '@mui/material/TextField'
import Autocomplete from '@mui/material/Autocomplete'

export const InputAutoComplete = ({
  name,
  control,
  label,
  required = false,
  options,
}) => {
  return (
    <Controller
      rules={{ required: required ? 'Ce champ est obligatoire' : false }}
      name={name}
      control={control}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <Autocomplete
          disablePortal
          options={options}
          getOptionLabel={(item) => item.name}
          isOptionEqualToValue={(item, value) => item.id === value.id}
          onChange={(_, item) => {
            onChange(item)
          }}
          value={value}
          renderInput={(params) => (
            <TextField
              {...params}
              label={label}
              helperText={error ? error.message : null}
              error={!!error}
              sx={{ mb: 3 }}
            />
          )}
        />
      )}
    />
  )
}
